import { Component, OnInit, ViewChild } from '@angular/core';
import { ListpluginsComponent } from 'projects/core/src/common/settingwindow/listplugins/listplugins.component';
import { Globals } from 'projects/core/src/globals';
import { Extension } from 'projects/core/src/include/parameters';
import { CSettingWindow, ISettingWindow } from 'projects/core/src/include/settingwindow';
import { SystemService } from 'projects/core/src/lib/system.service';
import { MethodpaymentsService } from '../../../services/methodpayments.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css'
})

@ISettingWindow.register

export class DocumentsSettingsComponent extends CSettingWindow implements OnInit {
  
  @ViewChild(ListpluginsComponent)
  listplugins:ListpluginsComponent;



  tab='2';
  module:Extension;

  banks:any=[];
  default_bank:string;
  default_iban:boolean;
  methodpayments=[];
  default_methodpayment:string;
  causals:any=[];
  default_causal_buy:string;
  default_causal_sell:string;
  sectionals:any=[];
  default_separator:string;
  referenceprefix:string;
  enablewelfarefund:boolean;
  percentualwelfarefund:number;
  percentualtaxwelfarefund:number;
  typewelfarefund:string;
  

  constructor(
    public systemService:SystemService,
    private methodpaymentsService:MethodpaymentsService
  ){
    super(systemService);
    this.getServerPluginsSettings("document");
    
  }

  ngOnInit(): void {
    
    this.methodpaymentsService.getMethods().subscribe((items_m)=>{
        this.methodpayments=items_m;
      });

    this.module=Globals.parameters.get("documents");

    this.banks=this.module.getParam("banks",[]);
    this.default_bank=this.module.getParam("default_bank",'');
    this.default_iban=this.module.getParam("default_iban",false);
    this.default_methodpayment=this.module.getParam("default_methodpayment",'Contanti');
    this.causals=this.module.getParam("causals",[]);
    this.default_causal_buy=this.module.getParam("default_causal_buy",'');
    this.default_causal_sell=this.module.getParam("default_causal_sell",'');    
    this.sectionals=this.module.getParam("sectionals",[]);
    this.default_separator=this.module.getParam("default_separator",'');
    this.referenceprefix=this.module.getParam("referenceprefix",'');
    this.enablewelfarefund=this.module.getParam("enablewelfarefund",false);
    this.percentualwelfarefund=this.module.getParam("percentualwelfarefund",4);
    this.percentualtaxwelfarefund=this.module.getParam("percentualtaxwelfarefund",22);
   

  }

  save(){
    this.module.setParam("banks",this.banks);
    this.module.setParam("default_bank",this.default_bank);
    this.module.setParam("default_iban",this.default_iban);
    this.module.setParam("default_methodpayment",this.default_methodpayment);
    this.module.setParam("causals",this.causals);
    this.module.setParam("default_causal_buy",this.default_causal_buy);
    this.module.setParam("default_causal_sell",this.default_causal_sell);
    this.module.setParam("sectionals",this.sectionals);
    this.module.setParam("default_separator",this.default_separator);
    this.module.setParam("referenceprefix",this.referenceprefix);
    this.module.setParam("enablewelfarefund",this.enablewelfarefund);
    this.module.setParam("percentualwelfarefund",this.percentualwelfarefund);
    this.module.setParam("percentualtaxwelfarefund",this.percentualtaxwelfarefund);

    this.module.save();
    this.savePlugins();
  }

  savePlugins(){
    this.listplugins.saveServerPlugins();
  }
  
  addBank(){
    this.banks.push({"name":"","iban":""});
  }

  deleteBank(b){
    for(let i=0;i<this.banks.length;i++){
      if(this.banks[i]==b){
        this.banks.splice(i,1);
        return;
      }
    }
  }



  addCausal(){
    this.causals.push({"description":""});
  }

  deleteCausal(c){
    for(let i=0;i<this.causals.length;i++){
      if(this.causals[i]==c){
        this.causals.splice(i,1);
        return;
      }
    }
  }

  addSectional(){
    this.sectionals.push({"label":"","code":""});
  }

  deleteSectional(s){
    for(let i=0;i<this.sectionals.length;i++){
      if(this.sectionals[i]==s){
        this.sectionals.splice(i,1);
        return;
      }
    }
  }
   
}